// extracted by mini-css-extract-plugin
export default {"forgotModal":"ForgotPasswordModal_forgotModal__1soi+","forgotTip":"ForgotPasswordModal_forgotTip__oFp5s","submitButton":"ForgotPasswordModal_submitButton__8ny-S"};